// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Size} from './size.js'

export class SetSize {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): SetSize {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsSetSize(bb: flatbuffers.ByteBuffer, obj?: SetSize): SetSize {
    return (obj || new SetSize()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsSetSize(bb: flatbuffers.ByteBuffer, obj?: SetSize): SetSize {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new SetSize()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  value(obj?: Size): Size | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Size()).__init(this.bb_pos + offset, this.bb!) : null
  }

  static startSetSize(builder: flatbuffers.Builder) {
    builder.startObject(1)
  }

  static addValue(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, valueOffset, 0)
  }

  static endSetSize(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    return offset
  }

  static createSetSize(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset): flatbuffers.Offset {
    SetSize.startSetSize(builder)
    SetSize.addValue(builder, valueOffset)
    return SetSize.endSetSize(builder)
  }
}
